/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when sitter clicks on arrows to move throught the months
 *
 * &nbsp;
 */
export class SitterProfileCalendarMonthChangeEvent extends AnalyticsEvent {
  eventName = 'sitter-profile-calendar-month-changed';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.platform.experiments;

  constructor(eventProperties: { pageVariant: string }) {
    super(eventProperties);
  }
}
